<template>
  <le-dialog title="选择链路关系" custom-class="le-job-line-relation-dialog" :visible.sync="visible" :modal="false" width="600px">
    <el-form ref="leJobLineRelationForm" :model="jobInfo">
      <div class="le-job-line-row">
        <div class="le-job-col le-job-from">
          <div class="le-job-col job-icon">
            <div class="icon-box">
              <i :class="jobInfo.sourceIcon" />
            </div>
          </div>
          <div class="le-job-col job-info">
            <div class="info-text job-name">{{ jobInfo.sourceLabel }}</div>
            <div class="info-text job-model">{{ jobInfo.sourceModel }}</div>
            <div class="info-text job-ip">{{ jobInfo.sourceIpAddress }}</div>
          </div>
        </div>
        <div class="le-job-col le-job-line">
          <div class="job-line">
            <i class="lt tp-lian-lu-jian-tou" />
          </div>
        </div>
        <div class="le-job-col le-job-to">
          <div class="le-job-col job-icon">
            <div class="icon-box">
              <i :class="jobInfo.targetIcon" />
            </div>
          </div>
          <div class="le-job-col job-info">
            <div class="info-text job-name">{{ jobInfo.targetLabel }}</div>
            <div class="info-text job-model">{{ jobInfo.targetModel }}</div>
            <div class="info-text job-ip">{{ jobInfo.targetIpAddress }}</div>
          </div>
        </div>
      </div>

      <div class="le-job-line-row le-flex-column">
        <h4 class="group-name">选择关系</h4>
        <div class="group-row">
          <div class="le-job-col le-logic-col">
            <el-select v-model="jobInfo.jobLine.logicType" placeholder="逻辑类型">
              <el-option label="逻辑" value="logic" />
              <el-option label="物理" value="physics" />
            </el-select>
          </div>

          <div class="le-job-col le-relation-col">
            <el-select v-model="jobInfo.jobLine.relationType" placeholder="请选择关系类型">
              <el-option label="包含" value="contain" />
              <el-option label="使用" value="use" />
            </el-select>
          </div>
        </div>
      </div>

      <div class="le-job-line-row le-flex-column">
        <h4 class="group-name">关系说明</h4>
        <div class="group-row">
          <el-input v-model="jobInfo.jobLine.relationRemarks" type="textarea" placeholder="关系说明" maxlength="255" :show-word-limit="true" />
        </div>
      </div>

      <div class="le-job-line-row">
        <div class="le-table-col">
          <el-table
            ref="sourcePortTable"
            class="le-table le-relate-table" 
            :data="jobInfo.sourcePortList"
            :stripe="true"
            border
            max-height="200"
            :highlight-current-row="true"
            @current-change="handleFromEvent">

            <el-table-column prop="label" label="端口" min-width="140" />
            <el-table-column prop="portSpeed" label="端口速率" min-width="80" />

            <template slot="empty">
              <el-empty description="暂无数据" />
            </template>
          </el-table>
        </div>

        <div class="le-table-col">
          <el-table
            ref="targetPortTable"
            class="le-table le-relate-table"
            :data="jobInfo.targetPortList"
            :stripe="true"
            border
            max-height="200"
            :highlight-current-row="true"
            @current-change="handleToEvent">

            <el-table-column prop="label" label="端口" min-width="140" />
            <el-table-column prop="portSpeed" label="端口速率" min-width="80" />

            <template slot="empty">
              <el-empty description="暂无数据" />
            </template>
          </el-table>
        </div>
      </div>

      <div class="le-btn-row">
        <el-button class="le-btn le-btn-default" @click="handleCancelEvent">取消</el-button>
        <el-button class="le-btn le-btn-primary" @click="handleSaveEvent">保存</el-button>
      </div>
    </el-form>
  </le-dialog>
</template>

<script>
import {childMixins, commonMixins} from '../../scripts/mixins';
import {edgeCore} from '../../scripts/core/logic';
import {generalEvent} from '../../scripts/conf/constants/event_name_const';
import {getTopologyNodeExtendInfoById} from '../../scripts/data';

export default {
  name: 'LeTpJobLineRelation',
  mixins: [commonMixins, childMixins],
  data() {
    return {
      visible: false,
      saveStatus: false,
      dbClickStatus: false,
      edgeItem: null,
      jobInfo: {
        sourceNodeId: '',
        sourceIcon: '',
        sourceLabel: '',
        sourceModel: '',
        sourceIpAddress: '',
        sourcePortList: [],
        targetNodeId: '',
        targetIcon: '',
        targetLabel: '',
        targetModel: '',
        targetIpAddress: '',
        targetPortList: [],
        jobLine: {
          logicType: 'logic',
          relationType: 'contain',
          relationRemarks: '',
          portSourceId: '',
          portTargetId: ''
        }
      }
    };
  },
  watch: {
    visible(status) {
      if (status) {
        this.saveStatus = !status;
      }

      // 处理删除边
      if (!status && !this.saveStatus && !this.dbClickStatus) {
        this.handleRemoveEdgeEvent();
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.initGlobalEvent();
    });
  },
  destroyed() {
    // 销毁自定义全局事件
    this.$bus.$off();
  },
  methods: {
    initGlobalEvent() {
      this.$bus.$on(['custom:edge:timing:afterCreateEdge', 'custom:edge:timing:dbClick'], evt => {
        this.visible = true;
        this.dbClickStatus = evt.name === generalEvent.dblClick;
        this.edgeItem = this.dbClickStatus ? evt.item : evt.edge;

        // 提取边数据
        this.initDefaultData();
        this.loadNodeExtendInfo();
      });
    },
    initDefaultData() {
      const sourceModel = this.edgeItem?.getSource()?.getModel();
      const targetModel = this.edgeItem?.getTarget()?.getModel();
      const edgeModel = this.edgeItem?.getModel();

      this.jobInfo = {...this.jobInfo, ...{
        sourceNodeId: sourceModel?.id,
        sourceIcon: sourceModel?.iconContent,
        sourceLabel: sourceModel?.label,
        sourceModel: '',
        sourceIpAddress: sourceModel?.ipAddress,

        targetNodeId: targetModel?.id,
        targetIcon: targetModel?.iconContent,
        targetLabel: targetModel?.label,
        targetModel: '',
        targetIpAddress: targetModel?.ipAddress,
          
        jobLine: {
          logicType: edgeModel?.logicType,
          relationType: edgeModel?.relationType,
          relationRemarks: edgeModel?.relationRemarks,
          portSourceId: edgeModel?.portSourceId,
          portTargetId: edgeModel?.portTargetId
        }
      }};
    },
    loadNodeExtendInfo() {
      getTopologyNodeExtendInfoById(this.jobInfo.sourceNodeId).then(resp => {
        const nodeExtendInfo = resp.data;
        this.jobInfo.sourceModel = nodeExtendInfo?.nodeModel;
        this.jobInfo.sourcePortList = nodeExtendInfo?.records;

        if (this.jobInfo.jobLine.portSourceId) {
          const row = this.jobInfo.sourcePortList.find(item => (item.id || item.idField) === this.jobInfo.jobLine.portSourceId);
          this.$refs.sourcePortTable.setCurrentRow(row);
        }
      });


      getTopologyNodeExtendInfoById(this.jobInfo.targetNodeId).then(resp => {
        const nodeExtendInfo = resp.data;
        this.jobInfo.targetModel = nodeExtendInfo?.nodeModel;
        this.jobInfo.targetPortList = nodeExtendInfo?.records;

        if (this.jobInfo.jobLine.portTargetId) {
          const row = this.jobInfo.targetPortList.find(item => (item.id || item.idField) === this.jobInfo.jobLine.portTargetId);
          this.$refs.targetPortTable.setCurrentRow(row);
        }
      });
    },
    handleCancelEvent() {
      this.visible = false;
    },
    handleSaveEvent() {
      this.saveStatus = true;
      this.getCanvasStage().updateItem(this.edgeItem, this.jobInfo.jobLine);
      this.handleResetFrom();
      this.edgeItem = null;
      this.visible = false;
    },
    handleFromEvent(row) {
      this.jobInfo.jobLine.portSourceId = row?.id || row?.idField;
    },
    handleToEvent(row) {
      this.jobInfo.jobLine.portTargetId = row?.id || row?.idField;
    },

    handleRemoveEdgeEvent() {
      // 处理删除边
      if (this.edgeItem) {
        // 删除该线条
        this.getCanvasStage().removeItem(this.edgeItem);
        // 计算边坐标和曲线
        edgeCore.computeEdgePoints(this);
      }
    },
    handleResetFrom() {
      this.jobInfo.jobLine.logicType = 'logic';
      this.jobInfo.jobLine.relationType = 'contain';
      this.jobInfo.jobLine.relationRemarks = '';
      this.jobInfo.jobLine.portSourceId = '';
      this.jobInfo.jobLine.portTargetId = '';
    }
  }
};
</script>

<style scoped>

</style>
